import { BaseEnum } from "../../BaseEnum";

export class FacilityType extends BaseEnum {
  static EDUCATION = 1;
  static FOOD_SALE = 2;
  static FOOD_SERVICE = 3;
  static HEALTH_CARE = 4;
  static LODGING = 5;
  static MANUFACTURING = 6;
  static MERCANTILE_OR_RETAIL = 7;
  static OFFICE = 8;
  static PUBLIC_ASSEMBLY = 9;
  static WAREHOUSE_AND_STORAGE = 10;
  static OTHER = 99;

  static Codes = [
    this.EDUCATION,
    this.FOOD_SALE,
    this.FOOD_SERVICE,
    this.HEALTH_CARE,
    this.LODGING,
    this.MANUFACTURING,
    this.MERCANTILE_OR_RETAIL,
    this.OFFICE,
    this.PUBLIC_ASSEMBLY,
    this.WAREHOUSE_AND_STORAGE,
    this.OTHER,
  ];

  static _labelKeys = [
    "enums.facility-type.EDUCATION",
    "enums.facility-type.FOOD_SALE",
    "enums.facility-type.FOOD_SERVICE",
    "enums.facility-type.HEALTH_CARE",
    "enums.facility-type.LODGING",
    "enums.facility-type.MANUFACTURING",
    "enums.facility-type.MERCANTILE_OR_RETAIL",
    "enums.facility-type.OFFICE",
    "enums.facility-type.PUBLIC_ASSEMBLY",
    "enums.facility-type.WAREHOUSE_AND_STORAGE",
    "enums.facility-type.OTHER",
  ];
}
